import { Dynamo } from '..';
import { SharedReport, WithTimestamps } from '../DynamoTypes';
import { ReportType } from '../reports';

export type GenerateReportRequest = {
    type: ReportType;
};

type ShareReportProps = {
    reportType: ReportType;
};

export type PendingReport = {
    status: 'pending';
} & ShareReportProps;

export type FailedReport = {
    status: 'failed';
} & ShareReportProps;

export type CompleteReport = {
    status: 'complete';
    downloadUrl: string;
} & ShareReportProps;

export type ReportItem = PendingReport | FailedReport | CompleteReport;

export type GetReportsResponse = {
    reports: ReportItem[];
};

export type CreateSharedReportRequest = {
    reportType: ReportType;
};

export type CreateSharedReportResponse = { sharedReport: SharedReport };

export type SharedReportItem = Omit<WithTimestamps<SharedReport>, 'shareCode' | 'creatorUserId'> & {
    shareCode: string | null;
} & {
    creatorUser: Dynamo.User;
} & {
    views: Dynamo.SharedReportView[];
};

export type GetProfileSharedReportsResponse = {
    sharedReports: SharedReportItem[];
};
